// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_9e1425b4d3--wrapper--B1pLq","_clickable":"_9e1425b4d3--_clickable--C2wCG"};